// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"e78749cd","189":"24cca6ed","451":"24cca6ed","640":"24cca6ed","983":"e78749cd"}[chunkId] + ".chunk.css";
};